import RadioTile from '@ramsey-design-system/radio-tile';
import { UseFormRegisterReturn } from 'react-hook-form';

interface GenericRadioTileGroupProps {
  options: Record<string, string>;
  idSuffix: string;
  registration: UseFormRegisterReturn;
  errorMessage?: string;
}

function GenericRadioTileGroup({
  options,
  idSuffix,
  registration,
  errorMessage
}: Readonly<GenericRadioTileGroupProps>) {
  return (
    <div className="mb-4 space-y-1.5">
      {Object.entries(options).map((entry) => {
        const key = entry[0];
        const value = entry[1];
        const id = key.concat(idSuffix);
        return (
          <RadioTile
            key={id}
            data-testid={id}
            {...registration}
            label={value}
            value={value}
            id={id}
            size="sm"
          />
        );
      })}
      {errorMessage && <p className="text-2 text-red-60">{errorMessage}</p>}
    </div>
  );
}

export { GenericRadioTileGroup };
